import React from "react";
import { Container, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PaymentDetails = () => {
  return (
    <>
      <Navbar />
      <Container className="py-5">
        <h2 className="text-center mb-4">Payment Details</h2>

        {/* Accepted Payment Methods */}
        <Card className="p-4 shadow-lg">
          
          <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">Accepted Payment Methods</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { name: "Bank Transfer", img: "/assets/img18.jpg", details: "Transfer funds directly to our bank account. Use your membership ID as the reference." },
              { name: "Mobile Payment", img: "/assets/img17.jpg", details: "Pay via M-Pesa, Airtel Money, or other mobile payment platforms. Use Paybill 123456, account number: Your Member ID." },
              { name: "Online Payment", img: "/assets/img6.jpg", details: "Pay securely using Visa, Mastercard, or PayPal through our online portal." },
            ].map((method, index) => (
              <div key={index} className="p-6 bg-white rounded-lg shadow-lg text-center">
                <img src={method.img} alt={method.name} className="w-full h-48 object-cover rounded-md mb-4" />
                <h3 className="text-xl font-semibold text-gray-800">{method.name}</h3>
                <p className="text-gray-600">{method.details}</p>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-4 shadow-lg w-full max-w-2xl mx-auto">
  <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">Payment Details</h3>
  
  <div className="flex flex-col items-center">
    <img src="/assets/img18.jpg" alt="Bank Account Details" className="w-full max-w-md h-48 object-cover rounded-md mb-4" />
    
    <div className="bg-white p-6 rounded-lg shadow-lg w-full">
      <h3 className="text-xl font-semibold text-gray-800 text-center mb-4">Bank Account Details</h3>
      
      <p className="text-gray-600 text-center mb-2">Use the following details for direct bank transfers:</p>

      <ol className="list-decimal list-outside text-gray-600 pl-6">
        <li>Bank Name: XYZ Bank</li>
        <li>Account Number: 1234567890</li>
        <li>Branch: Main Branch</li>
      </ol>
    </div>
  </div>
</Card>


      

       
      </Container>
      <Footer />
    </>
  );
};

export default PaymentDetails;
